// extracted by mini-css-extract-plugin
var _1 = "App__App--TxRw8";
var _2 = "App__ContentWide--Llj80";
export { _1 as "App", _2 as "ContentWide" }
